import { PageDqp as Page } from '@types';
import * as Yup from 'yup';

const pageSchema = Yup.object({
	items: Yup.array().required(),
	metadata: Yup.object({
		totalCount: Yup.number().required(),
		limit: Yup.number().required(),
		offset: Yup.number().required(),
	}).required(),
});

const emptyPage: Page<never> = {
	items: [],
	metadata: {
		totalCount: 0,
		limit: 0,
		offset: 0,
	},
};

export class PageHelper {
	static validateDataOrEmpty<T>(data: Page<T>): Page<T> {
		try {
			pageSchema.validateSync(data);
			return data;
		} catch {
			return emptyPage;
		}
	}
}
